import { useCallback, useEffect } from "react";
import { useLimit } from "./useLimit";
import { useOffset } from "./useOffset";

export const usePagination = (pageSize: number) => {
  const [limit, setLimit] = useLimit();
  const [offset, setOffset] = useOffset();

  const currentPage = offset / limit + 1;

  useEffect(() => {
    setLimit(pageSize);
    setOffset(0);
  }, [pageSize]);

  const onPageChange = useCallback(
    page => {
      setOffset(page > currentPage ? offset + limit : offset - limit <= 0 ? 0 : offset - limit);
    },
    [offset, limit, setOffset],
  );

  return {
    limit,
    offset,
    currentPage,
    onPageChange,
    setOffset,
    setLimit,
  };
};
